import React from 'react'
import ContactLayout from './contactlayout';
import RegisterStore from './registerstore';

const RegisterStorePage = () => {
    return (
        <ContactLayout>
            <RegisterStore />
        </ContactLayout>
    )
}

export default RegisterStorePage
